$(function(){
  $(".js-toggle-trigger").on('click', function(){
    $(this).toggleClass('toggle-open');
    $(this).next('.js-toggle-target').toggle();
  });
  $(".js-link-block-toggle-wrapper").each(function(){
    const target = $(this).find(".js-link-block-toggle-target");
    if (target.outerHeight() > 68) {
      target.addClass('hide');
      $(this).find(".js-link-block-toggle-trigger").css('display','flex');
    }
  });
  $(".js-link-block-toggle-trigger").on('click', function(){
    if ($(this).parent(".js-link-block-toggle-wrapper").hasClass('display-all')) {
      $(".js-link-block-toggle-wrapper").removeClass('display-all');
      $(this).text("もっと見る").removeClass('opened');
    } else {
      $(".js-link-block-toggle-trigger").each(function(){
        $(this).text("もっと見る").removeClass('opened');
      });
      $(".js-link-block-toggle-wrapper").each(function(){
        $(this).removeClass('display-all');
      });
      $(this).text("閉じる").addClass('opened');
      $(this).parent(".js-link-block-toggle-wrapper").addClass('display-all');
    };
  });
  $(".js-collection-search-modal-trigger").on('click', function(e){
    e.preventDefault();
    $('body').css('overflow', 'hidden');
    $(".js-collection-search-modal").addClass('is-show');
  });
  $(".js-collection-search-modal-close").on('click', function(e){
    e.preventDefault();
    $('body').css('overflow', 'auto');
    $(".js-collection-search-modal").removeClass('is-show');
  });
  $(".js-sp-link-block-toggle").on('click', function(){
    if ($(this).parent(".js-sp-link-block").hasClass('active')) {
      $(".js-sp-link-block").removeClass('active');
    } else {
      $(".js-sp-link-block").each(function(){
        $(".js-sp-link-block").removeClass('active');
      });
      $(this).parent(".js-sp-link-block").addClass('active');
    };
    if ($(".js-sp-link-block").hasClass('active')) {
      $(".js-category-link-list-wrapper").addClass('active');
    } else {
      $(".js-category-link-list-wrapper").removeClass('active');
    }
  });
});